import LocataireList from "../../components/Locataire/LocataireList";
import ContentLayout from "../../components/UI/Layout/ContentLayout.tsx";
import { classnames } from "../../utils/index.jsx";
import styles from "../../components/UI/TitleSearchAdd.module.css";

export default function LocataireListPage() {
  return (
    <>
      <ContentLayout
        header={
          <>
            <div
              className={classnames(
                "container bg-blue paddingT10",
                styles.noBorder,
              )}
            >
              <h2 className={"text-center"}>Espace Locataires</h2>
            </div>
            <div className="blueSpace"></div>
          </>
        }
        body={<LocataireList />}
      />
    </>
  );
}
